/* AT2 EXPERIMENT - Wrapper pour tous les modals AT2 */

/**
 * Composant wrapper "dumb" qui affiche uniquement les modals AT2.
 *
 * ✨ Architecture:
 * - Hook (useAT2MessageCheck) = Toute la logique métier
 * - Wrapper (ce fichier) = Composant de présentation pur
 *
 * Responsabilités:
 * - Afficher les 3 modals AT2 (Analysis, Comparison, Sending)
 * - Transmettre les handlers fournis par le hook
 * - Aucune logique métier (handlers, useEffect, etc.)
 */

import { AT2_AnalysisModal } from './modal/AT2_AnalysisModal';
import { AT2_ComparisonModal } from './modal/AT2_ComparisonModal';
import { AT2_SendingModal } from './modal/AT2_SendingModal';
import type { AT2State, AT2ModalState } from './hook/useAT2MessageCheck';

type Props = {
    // États AT2 (lecture seule)
    at2State: AT2State;
    modalState: AT2ModalState;

    // Handlers fournis par le hook
    onSendImproved: (editedMessage: string) => Promise<void>;
    onSendOriginal: () => Promise<void>;
    onClose: () => void;
};

export function AT2_ModalsWrapper({
    at2State,
    modalState,
    onSendImproved,
    onSendOriginal,
    onClose,
}: Props): JSX.Element {
    return (
        <>
            {/* 🟤 Step 3: Modal "Analyse AT2 en cours..." */}
            <AT2_AnalysisModal open={modalState.showAnalysisModal} />

            {/* ✅ Modal "Envoi en cours..." (quand needsOptimization = false OU après choix utilisateur) */}
            <AT2_SendingModal open={modalState.showSendingModal} mode={at2State.mode} />

            {/* 🔶 Step 7-8: Modal de comparaison avec génération et actions */}
            <AT2_ComparisonModal
                open={modalState.showComparisonModal}
                originalMessage={at2State.originalMessage}
                improvedMessage={at2State.improvedMessage}
                missingElements={at2State.missingElements}
                generating={at2State.generating}
                mode={at2State.mode}
                onSendImproved={onSendImproved}
                onSendOriginal={onSendOriginal}
                onClose={onClose}
            />
        </>
    );
}
